import React from 'react';
import moment from 'moment-timezone';

import { AccessGrant as AccessGrantType } from 'types/access_grant';

interface Props {
  accessGrant: AccessGrantType;
}

// Access given for free has nothing to pay, cancel, or pause, so all there is to say is how long
// it lasts
const AccessGrant: React.FC<Props> = (props) => (
  <div className="d-flex flex-column gap-xs">
    <h4 className="u-margin-A-n"><strong>{props.accessGrant.subscriptionPlan.name}</strong></h4>

    <div className="small text-gray-light">
      Access until {moment.unix(props.accessGrant.expiresAt).format('MMMM D, YYYY')}.
    </div>
  </div>
);

export default AccessGrant;
